"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormErrorPl = void 0;
const _1 = require(".");
exports.FormErrorPl = {
    [_1.FormError.invalidEmail]: 'Niepoprawny email!',
    [_1.FormError.notAllowedValue]: 'Wartość niedozwolona!',
    [_1.FormError.required]: 'Pole jest wymagane!',
    [_1.FormError.tooLong]: 'Zbyt długie!',
    [_1.FormError.tooShort]: 'Zbyt krótkie!',
    [_1.FormError.notMatchedPasswords]: 'Hasła nie są takie same!',
    [_1.FormError.moreThenLimit]: 'Wartość za duża!',
    [_1.FormError.mustBeTrue]: 'Wartość musi być prawdą',
};
//# sourceMappingURL=errors.pl.js.map